import React, { useState } from 'react';
import cx from 'classnames';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { FontAwesomeIcon, VideoClipIcon } from '@magoosh/lib/icons';
import VideoPlayer, { VideoPlayerProps } from '@magoosh/organisms/video_player/template';

import ActivityCard from '../card';
import { Activity } from '../types';

import style from './style.module.scss';

interface Props {
  activities: Activity[];
  onVideoFinished?: () => void;
  video: VideoPlayerProps;
  videoTitle: string;
}

const VideoActivity: React.FC<Props> = (props) => {
  const [isFinished, setIsFinished] = useState(false);

  const handleVideoFinished = () => {
    setIsFinished(true);

    props.onVideoFinished && props.onVideoFinished();
  };

  const handleVideoRestarted = () => {
    setIsFinished(false);
  };

  if (isFinished && props.activities.length > 0) {
    return (
      <div
        className={cx(
          style.activityContainer,
          'align-items-center d-flex flex-column justify-content-center'
        )}
      >
        <div className={cx(style.activity, 'hidden-xs')}>
          <ActivityCard activities={props.activities} header />
        </div>

        <div className={style.rewatchVideo}>
          <div
            className="bg-white border-radius-all d-flex flex-column gap-m u-padding-A-s"
            style={{ border: '1px dashed #B5B1BB' }}
          >
            <div className="align-items-center d-flex gap-m">
              <div className="align-items-center d-flex gap-s flex-1">
                <div className="flex-none">
                  <VideoClipIcon />
                </div>

                <div><strong>{props.videoTitle}</strong></div>
              </div>

              <div>
                <DefaultFilledButton onClick={handleVideoRestarted} size="sm">
                  Rewatch
                </DefaultFilledButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <VideoPlayer {...props.video} onEnd={handleVideoFinished} />
    );
  }
};

export default VideoActivity;
